import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, Reveal, Overline } from "@/components/Motion";
import EditorialMarquee from "@/components/Marquee";

const CHAPTERS = [
  {
    num: "01",
    title: "The founder",
    body: "Zilleneal Digital is led by Karanvir Singh — a designer-developer who got tired of watching small businesses overpay for slow, generic websites. So he built the studio he wished existed: senior-level craft, honest pricing, and a process simple enough to explain over coffee.",
  },
  {
    num: "02",
    title: "The approach",
    body: "No account managers. No telephone game. You talk directly to the person designing and building your site. We keep the team deliberately small so every project gets obsessive attention — from the first sketch to the final line of code.",
  },
  {
    num: "03",
    title: "The place",
    body: "Proudly based in Alberta. We know the local market because we're part of it — the family-run restaurants, the main-street shops, the startups sprouting up across the province. Prairie roots, global standards.",
  },
];

const About = () => (
  <div className="pt-40" data-testid="about-page">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Overline>About the studio</Overline>
      <MaskedLines
        as="h1"
        className="mt-8 font-sora font-extrabold tracking-tighter leading-[1.0] text-4xl sm:text-6xl lg:text-7xl"
        lines={["Small studio.", "Big standards."]}
      />

      <div className="mt-20 max-w-4xl">
        <div className="space-y-20" data-testid="about-chapters">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <div className="flex gap-8 items-start border-t border-white/10 pt-10" data-testid={`about-chapter-${c.num}`}>
                <span className="font-sora font-extrabold text-5xl md:text-6xl text-outline shrink-0 leading-none">{c.num}</span>
                <div>
                  <h2 className="font-sora font-bold text-2xl md:text-3xl tracking-tight">{c.title}</h2>
                  <p className="mt-4 text-white/60 leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>

    <div className="mt-32">
      <EditorialMarquee
        outline
        items={["Design", "Develop", "Launch", "Grow", "Repeat"]}
      />
    </div>

    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28">
      <Reveal>
        <div className="flex flex-wrap items-center justify-between gap-8">
          <h2 className="font-sora font-extrabold tracking-tighter text-3xl md:text-5xl max-w-xl leading-[1.05]">
            Sound like your kind of <span className="text-gradient">studio?</span>
          </h2>
          <Link
            to="/contact"
            data-testid="about-cta-quote"
            className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand-blue to-brand-purple px-8 py-4 font-semibold transition-transform duration-300 hover:scale-[1.04]"
          >
            Start a conversation
            <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </div>
);

export default About;
